export default __webpack_public_path__ + "static/media/no-mentions.69c3025b.svg";